import React, { Component } from "react";
import {
  login,
  agentLogin,
  guestLogin,
  agentCategoryDashboard,
  setStateParams,
  successfulSignUp,
  setTokenTORedux,
  setLoginData,
  setEmail,
  setLoginStateParams,
} from "../../../Redux/Actions/webAppActions";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import history from "../../../Utils/History";
import { connect } from "react-redux";
import Button from "../../../Utils/GenericUI/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import TextField from "@material-ui/core/TextField";
import RModal from "../../../Utils/GenericUI/UserSignUpModal/Modal";
import ForgotPwdModal from "../../ForgotPassword/ForgotPwdModal";
import SimpleReactValidator from "simple-react-validator";
import { Text } from "react-internationalization";
import { VERDA_CONSTS } from "../../../Utils/StaticData/Constant";
import { isValidHttpUrl } from "../../../Utils/http";
class BeneficiaryLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      passwrd: "",
      showPswd: false,
      pswdEye: false,
      emailError: false,
      pswdError: false,
      agentLogin: false,
      snackBarOpen: false,
      vertical: "top",
      horizontal: "center",
      snackBarSeverty: "",
      snackBarMsg: "",
      popUp: false,
      RpopUp: false,
      PwdpopUp: false,
      isPwdEnabled: false,
    };
    this.validator = new SimpleReactValidator();
  }
  componentDidMount() {
    window.scroll(0, 0);
    this.setState({
      snackBarOpen: false,
    });
  }

  RopenModal = () => async (e) => {
    e.preventDefault();
    e.preventDefault();
    this.setState({
      RpopUp: true,
    });
  };
  RmodalClosed = () => {
    this.setState({
      RpopUp: false,
    });
  };
  handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const emailError = name === "email" && value === "";
    const pswdError = name === "passwrd" && value === "";
    this.setState({
      [name]: value,
      emailError: emailError,
      pswdError: pswdError,
    });
  };

  handleFocus = (name) => (event) => {
    event.preventDefault();

    this.setState({
      pswdEye: true,
    });
  };

  handleOnBlur = (name) => (event) => {
    event.preventDefault();
    const { email, passwrd, showPswd } = this.state;
    const emailError = name === "email" && email === "";
    const pswdError = name === "password" && passwrd === "";

    this.setState({
      emailError: emailError,
      pswdError: pswdError,
      pswdEye: showPswd,
    });
  };

  showPswd = (name, toggle) => (event) => {
    document.getElementById(name).focus();
    this.setState({
      pswdEye: true,
      showPswd: toggle,
    });
  };

  login = async (e) => {
    e.preventDefault();

    const { email, passwrd } = this.state;
    const emailError = !this.validator.check(email, "email") || email === "";

    const pswdError = passwrd === "";

    if (emailError) {
      if (email?.trim() === "") {
        this.setState({
          snackBarOpen: true,
          snackBarMsg:
            this.props.lang === "es"
              ? "La dirección de correo electrónico no puede estar vacía."
              : "Email Address Can't Be Empty.",
          snackBarSeverty: "error",
        });
        return;
      } else {
        this.setState({
          snackBarOpen: true,
          snackBarMsg:
            this.props.lang === "es"
              ? "Por favor ingrese una dirección de correo electrónico válida para iniciar sesión."
              : "Please enter a valid email address to login.",
          snackBarSeverty: "error",
        });
        return;
      }
    }

    if (this.state.isPwdEnabled === false) {
      this.setState({
        ...this.state,
        isPwdEnabled: true,
      });
      return;
    }
    if (pswdError) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "La contraseña no puede estar vacía"
            : "Password cannot be empty",
        snackBarSeverty: "error",
      });
      return;
    }

    let body = { customerId: this.props?.customerId, isAgent: "N" };
    await this.props.setEmail(this.state.email);
    const loginData = await this.props.login(
      body,
      this.state.email,
      this.state.passwrd,
      this.props?.customerId
    );

    this.props.agentLogin(false, "");

    if (
      loginData &&
      loginData.message === "SUCCESS" &&
      loginData.data.roles?.length === 0
    ) {
      this.props.setTokenTORedux(loginData.data.token);
      window.sessionStorage.setItem("token", loginData.data.token);
      window.sessionStorage.setItem("email", this.state.email);
      window.sessionStorage.setItem("guestLogin", false);
      window.sessionStorage.setItem("agentLogin", false);
      window.sessionStorage.setItem("agentLoggedIn", false);
      window.sessionStorage.setItem("beneficiaryLogin", true);
      window.sessionStorage.setItem("firstName", loginData.data.firstName);
      window.sessionStorage.setItem("userId", loginData.data.userId);
      this.props.setLoginData(loginData.data);
      window.sessionStorage.setItem(
        "authenticatedData",
        JSON.stringify(loginData.data)
      );
      this.props.successfulSignUp(false);
      this.props.setLoginStateParams("beneficiaryLogin", true);
      if (
        window.sessionStorage.getItem("isDeeplink") &&
        window.sessionStorage.getItem("isDeepEmail") === this.state.email
      ) {
        const validURL = isValidHttpUrl(
          window.sessionStorage.getItem("isDeeplink")
        );
        window.location.href = validURL;
        // history.push(window.sessionStorage.getItem("isDeeplink"));
      } else {
        window.sessionStorage.removeItem("isDeeplink");
        window.sessionStorage.removeItem("keyCloakData");
        history.push("/e-Enroll/select-pin");
      }
    } else {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "Correo electrónico o contraseña incorrectos o no autorizados"
            : "Incorrect or Unauthorized Email or Password",
        snackBarSeverty: "error",
      });
    }
  };

  continueAsGuest = async (event) => {
    event.preventDefault();
    this.setState({
      isPwdEnabled: false,
    });
    const { email } = this.state;
    const emailError = !this.validator.check(email, "email") || email === "";
    if (emailError) {
      if (email?.trim() === "") {
        this.setState({
          snackBarOpen: true,
          snackBarMsg:
            this.props.lang === "es"
              ? "La dirección de correo electrónico no puede estar vacía."
              : "Email Address Can't Be Empty.",
          snackBarSeverty: "error",
        });
        return;
      } else {
        this.setState({
          snackBarOpen: true,
          snackBarMsg:
            this.props.lang === "es"
              ? "Por favor ingrese una dirección de correo electrónico válida para iniciar sesión."
              : "Please enter a valid email address to login.",
          snackBarSeverty: "error",
        });
        return;
      }
    }
    const guestLoginData = await this.props.guestLogin({
      username: email,
      customerId: this.props?.customerId,
    });
    if (
      guestLoginData.message === "SUCCESS" ||
      guestLoginData.data.roles === null
    ) {
      this.props.agentLogin(false);
      this.props.setTokenTORedux(guestLoginData.data.token);
      await this.props.setEmail(this.state.email);
      window.sessionStorage.setItem("token", guestLoginData.data.token);
      window.sessionStorage.setItem("guestLogin", true);
      window.sessionStorage.setItem("agentLoggedIn", false);
      window.sessionStorage.setItem("beneficiaryLogin", false);
      window.sessionStorage.setItem("userId", "");
      history.push("/e-Enroll/select-pin");
      this.props.successfulSignUp(false);
      this.props.setLoginStateParams("isActive", true);
    } else {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "Usuario no autorizada."
            : "Unauthorized User.",
        snackBarSeverty: "error",
      });
    }
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };

  render() {
    const {
      email,
      passwrd,
      showPswd,
      pswdEye,
      vertical,
      horizontal,
      snackBarOpen,
      snackBarMsg,
      snackBarSeverty,
    } = this.state;

    return (
      <div id="userLogin">
        <div class=" mt-3 mg-footer-small">
          <RModal
            paddingHeading="5px"
            dialogTitle={<Text id="user.sign" />}
            show={this.state.RpopUp}
            RmodalClosed={() => {
              this.RmodalClosed();
            }}
            closeIcon={true}
          ></RModal>
          <ForgotPwdModal
            paddingHeading="5px"
            dialogTitle={<Text id="user.rstbtn" />}
            show={this.state.PwdpopUp}
            ForgetPwdmodalClosed={() => {
              this.setState({ PwdpopUp: false });
            }}
            closeIcon={true}
          ></ForgotPwdModal>
          <Snackbar
            open={snackBarOpen}
            autoHideDuration={6000}
            onClose={this.handleClose}
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
          >
            <Alert onClose={this.handleClose} severity={snackBarSeverty}>
              {snackBarMsg}
            </Alert>
          </Snackbar>

          <div class="container-Cambia">
            <div class="form-group">
              <div
                class="col-md-12"
                aria-autocomplete="both"
                aria-haspopup="false"
              >
                <TextField
                  label={<Text id="user.emailAdd" />}
                  variant="outlined"
                  type="email"
                  name="email"
                  fullWidth
                  error={!this.validator.check(email, "email") || email === ""}
                  className="beneficiary-guest-emailAddr"
                  value={email}
                  onChange={this.handleChange}
                  onFocus={this.handleFocus("email")}
                  onBlur={this.handleOnBlur("email")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      this.login(e);
                    }
                  }}
                  inputProps={{
                    autoComplete: "off",
                    spellcheck: "false",
                    "aria-autocomplete": "both",
                    "aria-haspopup": "false",
                  }}
                  //autoComplete="off" spellcheck="false" aria-autocomplete="both" aria-haspopup="false"
                />

                <br />
                <div className="beneficiary-guest-pwd-container">
                  {this.state.isPwdEnabled ? (
                    <TextField
                      label={<Text id="user.setValue" />}
                      variant="outlined"
                      inputProps={{
                        type: showPswd ? "text" : "password",
                        autoComplete: "new-password",
                      }}
                      id="password"
                      name="passwrd"
                      fullWidth
                      error={passwrd === ""}
                      className="beneficiary-guest-emailAddr"
                      value={passwrd}
                      onFocus={this.handleFocus("password")}
                      onBlur={this.handleOnBlur("password")}
                      onChange={this.handleChange}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          this.login(e);
                        }
                      }}
                    />
                  ) : null}
                  {pswdEye && this.state.isPwdEnabled ? (
                    <div
                      class="eyeIcon-password2"
                      onMouseUp={this.showPswd("password", false)}
                      onMouseDown={this.showPswd("password", true)}
                      onMouseOut={this.showPswd("password", false)}
                      onClick={this.showPswd("password", !showPswd)}
                    >
                      <RemoveRedEyeIcon className="eye-Icon-margin" />
                    </div>
                  ) : null}
                </div>
                <br />
              </div>
            </div>
            <div class="button-container-login-page login-button-margin">
              <Button
                className="btn-primary-login"
                id="signup"
                onButtonClick={this.login}
                buttonLabel={<Text id="user.beneficiary" />}
              />
              {this.props.customerId !== VERDA_CONSTS.ID && (
                <Button
                  className="btn-primary-login"
                  id="continue-as-guest"
                  onButtonClick={this.continueAsGuest}
                  buttonLabel={<Text id="user.guest" />}
                />
              )}
            </div>
          </div>
          <div class="d-flex flex-row">
            <div class="text-left forgot-pwd-container">
              <p>
                <a
                  onClick={() => {
                    this.setState({ PwdpopUp: true });
                  }}
                  className="forgot-pwd-style"
                >
                  <Text id="user.forget" />
                </a>
              </p>
            </div>
            <div class="text-right sign-up-container">
              <p>
                <Text id="user.donthaveacc" />{" "}
                <a
                  href=""
                  onClick={this.RopenModal()}
                  className="sign-up-style"
                >
                  <Text id="user.lSignUp" />
                </a>{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    lang: state.webApp.language,
    successignUp: state.login.successfulSignUp,
    customerId: state.login.customerId,
  };
};
const mapDispatchToProps = {
  login,
  agentLogin,
  guestLogin,
  setStateParams,
  agentCategoryDashboard,
  successfulSignUp,
  setTokenTORedux,
  setEmail,
  setLoginData,
  setLoginStateParams,
};
export default connect(mapStateToProps, mapDispatchToProps)(BeneficiaryLogin);
